import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  events: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {
  loadEvents ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .event.getAll()
      .then((events) => {
        dispatch('events/resetEvents', null, { root: true })
        commit('ADD_EVENT_ITEMS', { items: events })
        return events
      })
  },

  resetEvents ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_EVENT_ITEMS')
      resolve()
    })
  },

  addEvent ({ commit, rootGetters }, { event }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .event.create(event)
      .then((event) => {
        commit('ADD_EVENT_ITEM', { item: event })
        return event
      })
  },

  updateEvent ({ commit, rootGetters }, { event }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .event.update(event)
      .then((event) => {
        commit('UPDATE_EVENT_ITEM', { item: event })
        return event
      })
  },

  removeEvent ({ commit, rootGetters }, { event }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .event.delete(event)
      .then((event) => {
        commit('REMOVE_EVENT_ITEM', { item: event })
        return event
      })
  }
}

// mutations
const mutations = {
  ADD_EVENT_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_EVENT_ITEMS: (state) => {
    state.items = []
  },

  ADD_EVENT_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_EVENT_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
      }
    }
  },
  REMOVE_EVENT_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js